import { render, staticRenderFns } from "./TableIndicators.vue?vue&type=template&id=aecb2904"
import script from "./TableIndicators.vue?vue&type=script&lang=js"
export * from "./TableIndicators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports